import { ArcSeg2d } from '@/editor/math/arcSeg2d';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { IShapePoint2d } from '@/editor/types/shape';

/**
 * 去除形状点上的弧线元数据（center/clockwise），返回只含坐标的纯点。
 */
export function toPlainPoint(point: IPoint2d): IPoint2d {
  return { x: point.x, y: point.y };
}

/**
 * 将带弧线元数据的形状路径离散成纯点序列。
 * 当某条边的起点带有 center 时，该边为弧线，用 ArcSeg2d 采样为多个点；否则按直线处理。
 */
export function sampleShapePath(path: IShapePoint2d[]): IPoint2d[] {
  if (!path.length) return [];

  const points: IPoint2d[] = [toPlainPoint(path[0])];

  for (let i = 0; i < path.length; i++) {
    const start = path[i];
    const end = path[(i + 1) % path.length];
    const isClosingEdge = i === path.length - 1;

    if (start.center) {
      const arc = new ArcSeg2d({ start, end, center: start.center, clockwise: start.clockwise ?? false });
      const arcPoints = arc.getPoints();
      const endIndex = isClosingEdge ? arcPoints.length - 1 : arcPoints.length;
      for (let j = 1; j < endIndex; j++) {
        points.push(toPlainPoint(arcPoints[j]));
      }
    } else {
      if (!isClosingEdge) points.push(toPlainPoint(end));
    }
  }

  return points;
}

/**
 * 对多个轮廓分别离散采样，并过滤掉空轮廓。
 */
export function sampleOutlines(outlines: IShapePoint2d[][]): IPoint2d[][] {
  return outlines.map(sampleShapePath).filter((outline) => outline.length);
}
